'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./~/react-slick/lib/index.js
// module id = 174
// module chunks = 0